module.exports = __webpack_public_path__ + "static/img/C4D0032.080d389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0032.jpg
// module id = mFLm
// module chunks = 0